// @ts-ignore
import Masonry from 'masonry-layout';
// @ts-ignore
import ImagesLoaded from 'imagesloaded';

export class ImageGallery {
  gallery: HTMLElement;

  constructor(gallery: HTMLElement) {
    this.gallery = gallery;
    this.addTriggerEvents();
  }

  addTriggerEvents() {
    const msnry = new Masonry(this.gallery, {
      itemSelector: "[data-image-gallery-item]"
    });
    ImagesLoaded('[data-image-gallery]', () => {
      msnry.layout();
    });
  }

}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll<HTMLElement>('[data-image-gallery]').forEach((gallery) => {
    new ImageGallery(gallery);
  });
});
